import {CdkScrollable, ScrollDispatcher} from '@angular/cdk/overlay';
import {AsyncPipe} from '@angular/common';
import {Component, NgZone, OnInit} from '@angular/core';
import {AssetService} from '@app/asset/asset.service';
import {PreferencesService} from '@app/preferences/preferences.service';
import {AsyncSpinnerComponent} from '@app/shared/async-spinner/async-spinner.component';
import {StorageService} from '@app/shared/storage.service';

import {Observable} from 'rxjs';
import {startWith} from 'rxjs/operators';
import {AssetThumbnailComponent} from '../asset-thumbnail/asset-thumbnail.component';
import {Asset, deserializeAsset} from '../models';

@Component({
    selector: 'frog-asset-list',
    templateUrl: './asset-list.component.html',
    styleUrls: ['./asset-list.component.scss'],
    imports: [AsyncSpinnerComponent, AssetThumbnailComponent, AsyncPipe],
})
export class AssetListComponent implements OnInit {
    public assets$: Observable<Asset[]>;
    public loading$: Observable<boolean>;
    public preferences$: Observable<any>;
    public multiplier: number;
    private readonly buffer = 300;

    constructor(
        private assetService: AssetService,
        private preferencesService: PreferencesService,
        private storageService: StorageService,
        private scrollService: ScrollDispatcher,
        private zone: NgZone,
    ) {
        this.multiplier = 1;
    }

    ngOnInit(): void {
        this.assets$ = this.assetService.filteredAssets;
        this.loading$ = this.assetService.loading.pipe(startWith(true));
        this.preferences$ = this.preferencesService.preferences;

        this.scrollService.scrolled(250).subscribe((data: CdkScrollable) => {
            if (!data) {
                return;
            }

            // This will be used by MainComponent to restore scroll position
            this.storageService.set('scrollPosition', data.measureScrollOffset('top'));

            const scrollPos = data.measureScrollOffset('bottom');
            if (scrollPos < this.buffer) {
                this.zone.run(() => {
                    this.assetService.next();
                });
            }
        });
    }

    append() {
        const data = {
            id: '0',
            asset_type: 1,
            name: 'APPENDED',
            tags: [],
            author: {
                email: 'dsadsa@asdsa.com',
                name: 'dsdsad',
            },
        } as Asset;
        const asset = deserializeAsset(data);
        this.assetService.appendAsset(asset);
    }
}
